import Microgame from '../engine/Microgame.js';

export default class StopwatchGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Chrono !`, en: `Stopwatch!`, es: `¡Cronómetro!` },
            controls: { fr: `Déclenche le chrono et arrête-le au moment précis`, en: `Start the timer and stop it at the exact moment`, es: `Inicia el cronómetro y páralo en el momento exacto` },
            objective: { fr: `Arrête le temps sur l'objectif`, en: `Stop the time on the target`, es: `Detén el tiempo en el objetivo` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2 2"/><path d="M10 2h4"/><path d="M14 2 12 5"/></svg>`,
            actions: [
                { type: 'wait', duration: 2500 },
                { type: 'tap', x: 50, y: 50, duration: 180 },
                { type: 'wait', duration: 420 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.currentTime = 3.00; // Start at 3 seconds
        this.stopped = false;
        this.display = null;
    }

    setup() {
        // Difficulty Logic:
        // Base tolerance: 0.50s
        // Each round (if infinite) or level reduces tolerance.

        let tolerance = 0.50;
        let speedMult = 1.0;

        if (this.engine.activeChallenge) {
            const config = this.engine.activeChallenge.config || {};
            if (config.tolerance) tolerance = config.tolerance;

            // If Survival/Infinite, get harder every round
            if (this.engine.activeChallenge.mode === 'infinite') {
                const round = this.engine.challengesCompleted || 0;
                tolerance = Math.max(0.06, 0.50 - (round * 0.05));
                speedMult = 1.0 + (round * 0.1);
            }
        } else {
            // STANDARD (ALL GAMES) mode: scale with engine speed multiplier
            // speedMultiplier va de 1.0 à ~4.0
            const sm = this.engine.speedMultiplier || 1.0;

            // Timer countdown speed: de x1 (normal) à x2.5 (rapide mais lisible)
            speedMult = 1 + (sm - 1) * 0.5;

            // Tolerance shrinks: 0.50s à x1 → 0.15s à x4 (linéaire)
            tolerance = Math.max(0.15, 0.50 - (sm - 1) * 0.116);
        }

        this.tolerance = tolerance;
        this.speedMult = speedMult;

        this.engine.ui.instruction.textContent = `STOP AT 0! (< ${tolerance.toFixed(2)}s)`;
        this.hideTimer = true; // We use our own timer

        this.display = document.createElement('div');
        this.display.style.position = 'absolute';
        this.display.style.top = '50%';
        this.display.style.left = '50%';
        this.display.style.transform = 'translate(-50%, -50%)';
        this.display.style.fontSize = '5rem';
        this.display.style.fontFamily = 'monospace';
        this.display.style.color = this.primaryColor;
        this.display.style.textShadow = `0 0 20px ${this.primaryColor}`;
        this.display.textContent = "3.00";
        this.container.appendChild(this.display);

        this.onTap = this.onTap.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onTap);
    }

    onTap() {
        if (!this.active || this.stopped) return;
        this.stopped = true;

        // Check win condition (0.00 to tolerance)
        if (this.currentTime >= 0 && this.currentTime <= this.tolerance) {
            this.display.style.color = this.secondaryColor; // Green/Secondary
            this.display.style.textShadow = `0 0 20px ${this.secondaryColor}`;
            this.win();
        } else {
            this.display.style.color = this.primaryColor; // Fail (keep primary or maybe accent?)
            this.display.style.textShadow = `0 0 20px ${this.primaryColor}`;
            this.lose();
        }
    }

    update(dt) {
        if (!this.stopped) {
            this.currentTime -= (dt / 1000) * (this.speedMult || 1);
            if (this.currentTime < 0) this.currentTime = 0;
            this.display.textContent = this.currentTime.toFixed(2);

            // Visual feedback: Green when in safe zone
            if (this.currentTime <= this.tolerance && this.currentTime > 0) {
                this.display.style.color = this.secondaryColor;
                this.display.style.textShadow = `0 0 30px ${this.secondaryColor}`;
            } else {
                this.display.style.color = this.primaryColor;
                this.display.style.textShadow = `0 0 20px ${this.primaryColor}`;
            }

            if (this.currentTime <= 0) {
                this.stopped = true;
                this.lose(); // Failed to stop in time
            }
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onTap);
    }
}
